import { h, render } from 'preact'
import { Carrousel } from '../../components/carrousel/carrousel.jsx'
var isSmartphone = require('is-mobile')

import { SG1Logs } from '../modules/logs.js'

//!\ Orchestrator à supprimer : mettre getformat directement dans le composant ?

export const carrouselOrchestrator = (data, targetNode) => {
   try {
      if (targetNode === null) throw ('Pas de targetNode pour le carrousel')
      if (data.zones[0].data.slides.length === 0) throw ('Pas de bannieres dans les données')
      let format = getFormat(dataStoreHP.pageId, isSmartphone() ? 'mobile' : 'desktop')
      render(<Carrousel slides={data.zones[0].data.slides} format={format} DOMtarget={targetNode} />, targetNode)
   } catch (error) {
      console.error('Carrousel orchestrator', error)
      SG1Logs.incLog('Err_CORCH')
   }
}

const getFormat = (pageId, deviceType) => {
   let format = ''
   switch (pageId) {
      case 'hp-regulier':
         format = 'regulier'
         break
      case 'hp-occasionnel':
         format = 'occasionnel'
         break
      case 'hp-prospect':
         format = 'prospect'
         break
      case 'vitrine-boutique':
      case 'vitrine-boutique-client':
         format = 'boutique'
         break
      case 'n1-forfaits-prospect':
      case 'n1-forfaits':
      case 'shop':
         format = 'mobile'
         break
      case 'n1-tv-prospect':
      case 'n1-tv':
         format = 'tv'
         break
   }
   return deviceType === 'mobile' ? `${format}-mobile` : format
}
